import Question from './Question.vue'
export default Question
